import React from 'react'
import MuiAutocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import CircularProgress from '@mui/material/CircularProgress'
import Paper from '@mui/material/Paper'
import {useIsRtl} from 'store/Store.js'
import {i18n} from 'common.js'

const Autocomplete = ({
    options = [],
    onInputChange,
    onChange,
    isOptionEqualToValue,
    getOptionLabel,
    label,
    isLoading = false,
    ...otherProps
}) => {
    const isRtl = useIsRtl()

    return (
        <MuiAutocomplete
            PaperComponent={(props) => (
                <Paper {...props} style={{direction: isRtl ? 'rtl' : 'ltr'}} />
            )}
            options={options || []}
            onInputChange={onInputChange}
            onChange={onChange}
            isOptionEqualToValue={isOptionEqualToValue}
            getOptionLabel={getOptionLabel}
            noOptionsText={i18n.t('search.noOptions')}
            renderInput={(params) => (
                <TextField
                    label={label}
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            {...otherProps}
        />
    )
}

export default Autocomplete
